import { render, staticRenderFns } from "./ProductsDataTable.vue?vue&type=template&id=8ab91ea8&"
import script from "./ProductsDataTable.vue?vue&type=script&lang=ts&"
export * from "./ProductsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
